import { UploaderModule } from "./uploader/uploader.module";
import { TransitionNewModule } from "./transitions-new/transition-new.module";
import { TransitionModule } from "./transition/transition.module";
import { TopnavModule } from "./topnav/topnav.module";
import { TooltipModule } from "./tooltip/tooltip.module";
import { TextareaModule } from "./textarea/textarea.module";
import { TagModule } from "./tag/tag.module";
import { TabModule } from "./tab/tab.module";
import { SwitchModule } from "./switch/switch.module";
import { StepperModule } from "./stepper/stepper.module";
import { StatusModule } from "./status/status.module";
import { SpeechModule } from "./speech/speech.module";
import { SortModule } from "./sort/sort.module";
import { SnackbarModule } from "./snackbar/snackbar.module";
import { SliderModule } from "./slider/slider.module";
import { SidenavModule } from "./sidenav/sidenav.module";
import { PipesModule } from "./shared/pipes/pipes.module";
import { DirectivesModule } from "./shared/directives/directives.module";
import { SelectModule } from "./select/select.module";
import { RadioModule } from "./radio/radio.module";
import { ProgressbarModule } from "./progressbar/progressbar.module";
import { PointModule } from "./point/point.module";
import { MultiselectModule } from "./multiselect/multiselect.module";
import { MenuModule } from "./menu/menu.module";
import { ModalModule } from "./modal/modal.module";
import { MediaCardModule } from "./media-card/media-card.module";
import { LinkCardModule } from "./link-card/link-card.module";
import { LayoutModule } from "./layout/layout.module";
import { InputModule } from "./input/input.module";
import { IconModule } from "./icon/icon.module";
import { HeroModule } from "./hero/hero.module";
import { HelpTextModule } from "./help-text/help-text.module";
import { ExpandableContainerModule } from "./expandable-container/expandable-container.module";
import { ExpandableModule } from "./expandable/expandable.module";
import { DropdownModule } from "./dropdown/dropdown.module";
import { DatepickerModule } from "./datepicker/datepicker.module";
import { DatatableModule } from "./datatable/datatable.module";
import { CheckboxModule } from "./checkbox/checkbox.module";
import { CardModule } from "./card/card.module";
import { CaptionModule } from "./caption/caption.module";
import { ButtonToggleModule } from "./button-toggle/button-toggle.module";
import { ButtonModule } from "./button/button.module";
import { BreadcrumbModule } from "./breadcrumb/breadcrumb.module";
import { BlockModule } from "./block/block.module";
import { BadgeModule } from "./badge/badge.module";
import { AutocompleteModule } from "./autocomplete/autocomplete.module";
import { AlertModule } from "./alert/alert.module";
import { NgModule } from "@angular/core";
import { LabelModule } from "./label/label.module";
import { PaginatorModule } from "./paginator/paginator.module";
import { SpinnerModule } from "./spinner/spinner.module";
@NgModule({
	imports: [
	AlertModule,
	AutocompleteModule,
	BadgeModule,
	BlockModule,
	BreadcrumbModule,
	ButtonModule,
	ButtonToggleModule,
	CaptionModule,
	CardModule,
	CheckboxModule,
	DatatableModule,
	DatepickerModule,
	DropdownModule,
	ExpandableModule,
	ExpandableContainerModule,
	HelpTextModule,
	HeroModule,
	IconModule,
	InputModule,
	LabelModule,
	LayoutModule,
	LinkCardModule,
	MediaCardModule,
	ModalModule,
	MenuModule,
	MultiselectModule,
	PaginatorModule,
	PointModule,
	ProgressbarModule,
	RadioModule,
	SelectModule,
	DirectivesModule,
	PipesModule,
	SidenavModule,
	SliderModule,
	SnackbarModule,
	SortModule,
	SpeechModule,
	SpinnerModule,
	StatusModule,
	StepperModule,
	SwitchModule,
	TabModule,
	TagModule,
	TextareaModule,
	TooltipModule,
	TopnavModule,
	TransitionModule,
	TransitionNewModule,
	UploaderModule
],
	exports: [
	AlertModule,
	AutocompleteModule,
	BadgeModule,
	BlockModule,
	BreadcrumbModule,
	ButtonModule,
	ButtonToggleModule,
	CaptionModule,
	CardModule,
	CheckboxModule,
	DatatableModule,
	DatepickerModule,
	DropdownModule,
	ExpandableModule,
	ExpandableContainerModule,
	HelpTextModule,
	HeroModule,
	IconModule,
	InputModule,
	LabelModule,
	LayoutModule,
	LinkCardModule,
	MediaCardModule,
	ModalModule,
	MenuModule,
	MultiselectModule,
	PaginatorModule,
	PointModule,
	ProgressbarModule,
	RadioModule,
	SelectModule,
	DirectivesModule,
	PipesModule,
	SidenavModule,
	SliderModule,
	SnackbarModule,
	SortModule,
	SpeechModule,
	SpinnerModule,
	StatusModule,
	StepperModule,
	SwitchModule,
	TabModule,
	TagModule,
	TextareaModule,
	TooltipModule,
	TopnavModule,
	TransitionModule,
	TransitionNewModule,
	UploaderModule
]
})
export class LibraryModule {}
